<template>
    <div>
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <div class="row mb-5">
            <div class="col">
                <button @click="show('term', false)"
                    class="btn btn-block btn-secondary">{{$t('button.termTranscript')}}</button>
            </div>
            <div class="col">
                <button @click="show('year', false)"
                    class="btn btn-block btn-secondary">{{$t('button.yearTranscript')}}</button>
            </div>
            <div class="col" v-if="studentProgram.FoundationID">
                <button @click="show('yearFp', false)"
                    class="btn btn-block btn-secondary">{{$t('button.yearFpTranscript')}}</button>
            </div>
            <div class="col" v-if="studentProgram.Program2ID">
                <button @click="show('yearMerged', false)"
                    class="btn btn-block btn-secondary">{{$t('button.yearTranscriptMerged')}}</button>
            </div>
            <div class="col" v-if="studentProgram.Program2ID">
                <button @click="show('yearFull', false)"
                    class="btn btn-block btn-secondary">{{$t('button.yearFullTranscript')}}</button>
            </div>
            <div class="col">
                <button @click="show('full', false)"
                    class="btn btn-block btn-secondary">{{$t('button.fullTranscript')}}</button>
            </div>
            <div class="col" v-if="program_code == 'DBA'">
                <button @click="show('mabr', false)"
                    class="btn btn-block btn-secondary">{{$t('button.mabrTranscript')}}</button>
            </div>
        </div>

        <div class="row mb-2" v-if="showLocalGrades || showSecondaryLocalGrades">
            <h4>Local Grading Scale Transcripts</h4>
        </div>
        <div class="row mb-5" v-if="showLocalGrades || showSecondaryLocalGrades">
            <div class="col">
                <button @click="show('term', true)"
                    class="btn btn-block btn-secondary">{{$t('button.termTranscript')}}</button>
            </div>
            <div class="col">
                <button @click="show('year', true)"
                    class="btn btn-block btn-secondary">{{$t('button.yearTranscript')}}</button>
            </div>
            <div class="col" v-if="studentProgram.FoundationID">
                <button @click="show('yearFp', true)"
                    class="btn btn-block btn-secondary">{{$t('button.yearFpTranscript')}}</button>
            </div>
            <div class="col" v-if="studentProgram.Program2ID">
                <button @click="show('yearMerged', true)"
                    class="btn btn-block btn-secondary">{{$t('button.yearTranscriptMerged')}}</button>
            </div>
            <div class="col" v-if="studentProgram.Program2ID">
                <button @click="show('yearFull', true)"
                    class="btn btn-block btn-secondary">{{$t('button.yearFullTranscript')}}</button>
            </div>
            <div class="col">
                <button @click="show('full', true)"
                    class="btn btn-block btn-secondary">{{$t('button.fullTranscript')}}</button>
            </div>
            <div class="col" v-if="program_code == 'DBA'">
                <button @click="show('mabr', true)"
                    class="btn btn-block btn-secondary">{{$t('button.mabrTranscript')}}</button>
            </div>
        </div>

        <div class="row">
            <template v-if="inDisplay == 'term'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel' type="term" v-if="downloadBtns"></download-transcript>

                    <div class="card mb-3" v-for="semester in semesters" :key="semester"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px">
                        <div class="card-body">
                            
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="pages[semester] != undefined ? pages[semester] : ''"></top>

                            <h4 v-if="semester">{{semester}}. 
                                {{['BBA', 'AAE', 'DBA'].includes(program.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                            </h4>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{$t('transcript.code')}}</th>
                                            <th>{{$t('transcript.course')}}</th>
                                            <th v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                            <th v-else></th>
                                            <!-- <th v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                            <th>{{$t('transcript.grade')}}</th>
                                            <th v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">{{$t('transcript.sbsCredits')}}
                                            </th>
                                            <th v-else>{{$t('transcript.ectsCredits')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(course, index) in courses[semester]" :key="index">
                                            <td>{{course.course_code}}</td>
                                            <td>{{course.course_title}}</td>
                                            <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                            <td class="text-center" v-else></td>
                                            <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                            <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                            <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{course.sbs_credits}}</td>
                                            <td class="text-center" v-else>{{course.ects_credits}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4" v-if="local_transcripts">
                                                {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa[semester] !== undefined ? local_gpa[semester].local_gpa : 0, maximum_grade: maximum_grade})}}
                                            </th>
                                            <th colspan="4" v-else>
                                                {{$t('transcript.gradePointAverage', {gpa: gpa[semester] !== undefined ? gpa[semester].gpa : 0})}}
                                            </th>
                                            <th style="min-width: 100px" class="pl-4" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">
                                                    {{gpa[semester] !== undefined ? gpa[semester].sbs_credits : 0}}</span>
                                            </th>
                                            <th style="min-width: 100px" class="pl-4" v-else>{{$t('transcript.total')}}
                                                <span class="font-weight-normal">
                                                    {{gpa[semester] !== undefined ? gpa[semester].ects_credits : 0}}</span>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'year'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel' type="year" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-for="(page, academicYear) in pages" :key="academicYear">
                        <div class="card-body">
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="academicYear"></top>

                            <div v-for="(academicYear2, semester) in page" class="mb-3" :key="semester">
                                <h4 v-if="semester">{{semester}}. 
                                    {{['BBA', 'AAE', 'DBA'].includes(program.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                                </h4>

                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{{$t('transcript.code')}}</th>
                                                <th width="300px">{{$t('transcript.course')}}</th>
                                                <th width="100px" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                                <th width="100px" v-else></th>
                                                <!-- <th width="80px" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                                <th width="80px">{{$t('transcript.grade')}}</th>
                                                <th width="80px" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.sbsCredits')}}
                                                </th>
                                                <th width="100px" v-else>{{$t('transcript.ectsCredits')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, index) in courses[semester]" v-bind:key="index">
                                                <td>{{course.course_code}}</td>
                                                <td>{{course.course_title}}</td>
                                                <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                                <td class="text-center" v-else></td>
                                                <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                                <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{course.sbs_credits}}</td>
                                                <td class="text-center" v-else>{{course.ects_credits}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa[semester] !== undefined ? local_gpa[semester].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: gpa[semester] !== undefined ? gpa[semester].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].ects_credits : 0}}</span>
                                                </th>
                                            </tr>

                                            <tr v-if="semester == semesters">
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localCumulativeGPA', {local_gpa: local_gpa[0] !== undefined ? local_gpa[0].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.cumulativeGPA', {gpa: gpa[0] !== undefined ? gpa[0].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.totalSBS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.totalECTS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].ects_credits : 0}}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <template v-if="semester == semesters">
                                    <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'yearFp'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel' type="yearFp" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-for="(page, academicYear) in pages" :key="academicYear">
                        <div class="card-body">
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="academicYear"></top>

                            <div v-for="(academicYear2, semester) in page" class="mb-3" :key="semester">
                                <h4 v-if="semester">{{semester}}. 
                                    {{['BBA', 'AAE', 'DBA'].includes(program.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                                </h4>

                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{{$t('transcript.code')}}</th>
                                                <th width="300px">{{$t('transcript.course')}}</th>
                                                <th width="100px" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                                <th width="100px" v-else></th>
                                                <!-- <th width="80px" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                                <th width="80px">{{$t('transcript.grade')}}</th>
                                                <th width="80px" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.sbsCredits')}}
                                                </th>
                                                <th width="100px" v-else>{{$t('transcript.ectsCredits')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, index) in courses[semester]" v-bind:key="index">
                                                <td>{{course.course_code}}</td>
                                                <td>{{course.course_title}}</td>
                                                <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                                <td class="text-center" v-else></td>
                                                <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                                <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{course.sbs_credits}}</td>
                                                <td class="text-center" v-else>{{course.ects_credits}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa[semester] !== undefined ? local_gpa[semester].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: gpa[semester] !== undefined ? gpa[semester].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].ects_credits : 0}}</span>
                                                </th>
                                            </tr>

                                            <tr v-if="semester == semesters">
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localCumulativeGPA', {local_gpa: local_gpa[0] !== undefined ? local_gpa[0].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.cumulativeGPA', {gpa: gpa[0] !== undefined ? gpa[0].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.totalSBS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.totalECTS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].ects_credits : 0}}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <template v-if="semester == semesters">
                                    <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'yearMerged'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel' type="yearMerged" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-for="(page, academicYear) in pages" :key="academicYear + '-' + id">
                        <div class="card-body">
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="academicYear"></top>

                            <div v-for="(academicYear2, semester) in page" class="mb-3" :key="semester">
                                <h4 v-if="semester">{{semester}}. 
                                    {{['BBA', 'AAE', 'DBA'].includes(program.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                                </h4>

                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{{$t('transcript.code')}}</th>
                                                <th width="300px">{{$t('transcript.course')}}</th>
                                                <th width="100px" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                                <th width="100px" v-else></th>
                                                <!-- <th width="80px" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                                <th width="80px">{{$t('transcript.grade')}}</th>
                                                <th width="80px" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.sbsCredits')}}
                                                </th>
                                                <th width="100px" v-else>{{$t('transcript.ectsCredits')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, index) in courses[semester]" v-bind:key="index">
                                                <td>{{course.course_code}}</td>
                                                <td>{{course.course_title}}</td>
                                                <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                                <td class="text-center" v-else></td>
                                                <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                                <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{course.sbs_credits}}</td>
                                                <td class="text-center" v-else>{{course.ects_credits}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa[semester] !== undefined ? local_gpa[semester].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: gpa[semester] !== undefined ? gpa[semester].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].ects_credits : 0}}</span>
                                                </th>
                                            </tr>

                                            <tr v-if="semester == semesters">
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localCumulativeGPA', {local_gpa: local_gpa[0] !== undefined ? local_gpa[0].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.cumulativeGPA', {gpa: gpa[0] !== undefined ? gpa[0].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.totalSBS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.totalECTS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].ects_credits : 0}}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <template v-if="semester == semesters">
                                    <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-for="(secondary_page, academicYear) in secondary_pages" :key="academicYear + '-secondary' + id">
                        <div class="card-body">
                            <top :student="student" :program="program2" :report_date="report_date"
                                :local_gpa="secondary_local_gpa" :maximum_grade="secondary_maximum_grade" :local_transcripts="local_transcripts" :academic_year="academicYear"></top>

                            <div v-for="(academicYear2, semester) in secondary_page" class="mb-3" :key="semester">
                                <h4 v-if="semester">{{semester}}. 
                                    {{['BBA', 'AAE', 'DBA'].includes(program2.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                                </h4>

                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{{$t('transcript.code')}}</th>
                                                <th width="300px">{{$t('transcript.course')}}</th>
                                                <th width="100px" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                                <th width="100px" v-else></th>
                                                <!-- <th width="80px" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                                <th width="80px">{{$t('transcript.grade')}}</th>
                                                <th width="80px" v-if="program2.program_code == 'DBA' || program2.program_type =='CAP Program'">
                                                    {{$t('transcript.sbsCredits')}}
                                                </th>
                                                <th width="100px" v-else>{{$t('transcript.ectsCredits')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, index) in secondary_courses[semester]" v-bind:key="index">
                                                <td>{{course.course_code}}</td>
                                                <td>{{course.course_title}}</td>
                                                <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                                <td class="text-center" v-else></td>
                                                <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                                <td class="text-center" v-if="program2.program_code == 'DBA' || program2.program_type =='CAP Program'">
                                                    {{course.sbs_credits}}</td>
                                                <td class="text-center" v-else>{{course.ects_credits}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: secondary_local_gpa[semester] !== undefined ? secondary_local_gpa[semester].local_gpa : 0, maximum_grade: secondary_maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: secondary_gpa[semester] !== undefined ? secondary_gpa[semester].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program2.program_code == 'DBA' || program2.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{secondary_gpa[semester] !== undefined ? secondary_gpa[semester].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{secondary_gpa[semester] !== undefined ? secondary_gpa[semester].ects_credits : 0}}</span>
                                                </th>
                                            </tr>

                                            <tr v-if="semester == secondary_semesters">
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localCumulativeGPA', {local_gpa: secondary_local_gpa[0] !== undefined ? secondary_local_gpa[0].local_gpa : 0, maximum_grade: secondary_maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.cumulativeGPA', {gpa: secondary_gpa[0] !== undefined ? secondary_gpa[0].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program2.program_code == 'DBA' || program2.program_type =='CAP Program'">
                                                    {{$t('transcript.totalSBS')}}
                                                    <span class="font-weight-normal">
                                                        {{secondary_gpa[0] !== undefined ? secondary_gpa[0].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.totalECTS')}}
                                                    <span class="font-weight-normal">
                                                        {{secondary_gpa[0] !== undefined ? secondary_gpa[0].ects_credits : 0}}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <template v-if="semester == secondary_semesters">
                                    <bottom :student="student" :program="program2" :registrar="registrar"></bottom>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'full'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel'  type="full" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px">
                        <div class="card-body">
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="program.academic_year"></top>
                            <div v-if="program.program_code == 'AAE'" class="mb-3">
                                <strong>{{$t('transcript.aaeRemarksTerm')}}</strong>
                            </div>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{$t('transcript.code')}}</th>
                                            <th>{{$t('transcript.course')}}</th>
                                            <th class="text-center" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                            <th class="text-center" v-else></th>
                                            <!-- <th class="text-center" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                            <th class="text-center">{{$t('transcript.grade')}}</th>
                                            <th class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.sbsCredits')}}
                                            </th>
                                            <th class="text-center" v-else>{{$t('transcript.ectsCredits')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(course, index) in courses" :key="index">
                                            <td>{{course.course_code}}</td>
                                            <td>{{course.course_title}}</td>
                                            <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                            <td class="text-center" v-else></td>
                                            <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                            <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                            <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-if="program.program_code == 'DBA' ||  program.program_type =='CAP Program'">
                                                {{course.sbs_credits}}</td>
                                            <td class="text-center" v-else>{{course.ects_credits}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr v-if="secondary_courses.length">
                                            <th colspan="4"></th>
                                            <th  class="pl-4"  style="min-width: 100px"
                                                v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{sbs_credits}}</span>
                                            </th>
                                            <th class="pl-4"  style="min-width: 100px" v-else>
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{ects_credits}}</span>
                                            </th>
                                        </tr>
                                        <template v-if="!secondary_courses.length">
                                            <tr>
                                               <th colspan="4" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="4" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: gpa})}}
                                                </th>
                                                <th  class="pl-4" style="min-width: 100px;"
                                                    v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">{{total_sbs_credits}}</span>
                                                </th>
                                                <th  class="pl-4" style="min-width: 100px;" v-else>
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">{{total_ects_credits}}</span>
                                                </th>
                                            </tr>
                                            <template v-if="program.program_code=='AAE'">
                                                <tr>
                                                    <th colspan="5" style="text-align:right; padding-right: 4rem">
                                                        {{$t('transcript.aaeRemarksCredit')}}
                                                        <span class="font-weight-normal">120</span>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th colspan="5" style="text-align:right; padding-right: 4rem">
                                                        {{$t('transcript.totalECTS')}}
                                                        <span class="font-weight-normal">{{total_ects_credits + 120}}</span>
                                                    </th>
                                                </tr>
                                            </template>
                                        </template>
                                    </tfoot>
                                </table>
                            </div>

                            <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                        </div>
                    </div>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-if="secondary_courses.length">
                        <div class="card-body">

                            <top :student="student" :program="secondary_program" :local_gpa="local_gpa" :maximum_grade="maximum_grade" :report_date="report_date" :local_transcripts="local_transcripts"
                                :academic_year="secondary_program.academic_year"></top>

                            <div v-if="secondary_program.program_code == 'AAE'">
                                {{$t('transcript.aaeRemarksTerm')}}
                            </div>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{$t('transcript.code')}}</th>
                                            <th>{{$t('transcript.course')}}</th>
                                            <th class="text-center" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                            <th class="text-center" v-else></th>
                                            <!-- <th class="text-center" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                            <th class="text-center">{{$t('transcript.grade')}}</th>
                                            <th class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.sbsCredits')}}
                                            </th>
                                            <th class="text-center" v-else>{{$t('transcript.ectsCredits')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(course, index) in secondary_courses" :key="index">
                                            <td>{{course.course_code}}</td>
                                            <td>{{course.course_title}}</td>
                                            <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                            <td class="text-center" v-else></td>
                                            <td class="text-center" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                            <td class="text-center" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-else>{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{course.sbs_credits}}</td>
                                            <td class="text-center" v-else>{{course.ects_credits}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4"></th>
                                            <th class="text-center" style="min-width: 100px"
                                                v-if="secondary_program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{secondary_sbs_credits}}</span>
                                            </th>
                                            <th class="text-center" style="min-width: 100px" v-else>
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{secondary_ects_credits}}</span>
                                            </th>
                                        </tr>
                                        <tr v-if="secondary_program.program_code=='AAE'">
                                            <th colspan="3"></th>
                                            <th colspan="2">
                                                {{$t('transcript.aaeRemarksCredit')}}
                                                <span class="font-weight-normal">120</span>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="3" v-if="local_transcripts">
                                                {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa, maximum_grade: maximum_grade})}}
                                            </th>
                                            <th colspan="3" v-else>
                                                {{$t('transcript.gradePointAverage', {gpa: gpa})}}
                                            </th>
                                            <th colspan="2" style="min-width: 100px;text-align: center;"
                                                v-if="secondary_program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.totalSBS')}}
                                                <span class="font-weight-normal">{{total_sbs_credits}}</span>
                                            </th>
                                            <th colspan="2" style="min-width: 100px;text-align: center;" v-else>
                                                {{$t('transcript.totalECTS')}}
                                                <span class="font-weight-normal">{{total_ects_credits}}</span>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <p><strong>{{$t('transcript.page1')}}</strong></p>

                            <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'yearFull'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel' type="yearFull" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-for="(page, academicYear) in pages" :key="academicYear">
                        <div class="card-body">
                            <top :student="student" :program="program" :report_date="report_date"
                                :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :academic_year="academicYear"></top>

                            <div v-for="(academicYear2, semester) in page" class="mb-3" :key="semester">
                                <h4 v-if="semester">{{semester}}. 
                                    {{['BBA', 'AAE', 'DBA'].includes(program.program_code) ? $t('transcript.semester') : $t('transcript.term')}}
                                </h4>

                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th width="80px">{{$t('transcript.code')}}</th>
                                                <th width="300px">{{$t('transcript.course')}}</th>
                                                <th width="100px" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                                <th width="100px" v-else></th>
                                                <!-- <th width="80px" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                                <th width="80px">{{$t('transcript.grade')}}</th>
                                                <th width="80px" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.sbsCredits')}}
                                                </th>
                                                <th width="100px" v-else>{{$t('transcript.ectsCredits')}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(course, index) in courses[semester]" v-bind:key="index">
                                                <td>{{course.course_code}}</td>
                                                <td>{{course.course_title}}</td>
                                                <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                                <td class="text-center" v-else></td>
                                                <td align="left" style="padding-left:4%;" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                                <td align="left" style="padding-left:4%;" v-else>{{course.descriptive_grade}}</td>
                                                <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{course.sbs_credits}}</td>
                                                <td class="text-center" v-else>{{course.ects_credits}}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa[semester] !== undefined ? local_gpa[semester].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.gradePointAverage', {gpa: gpa[semester] !== undefined ? gpa[semester].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.total')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[semester] !== undefined ? gpa[semester].ects_credits : 0}}</span>
                                                </th>
                                            </tr>

                                            <tr v-if="semester == semesters">
                                                <th colspan="3" v-if="local_transcripts">
                                                    {{$t('transcript.localCumulativeGPA', {local_gpa: local_gpa[0] !== undefined ? local_gpa[0].local_gpa : 0, maximum_grade: maximum_grade})}}
                                                </th>
                                                <th colspan="3" v-else>
                                                    {{$t('transcript.cumulativeGPA', {gpa: gpa[0] !== undefined ? gpa[0].gpa : 0})}}
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                    {{$t('transcript.totalSBS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].sbs_credits : 0}}</span>
                                                </th>
                                                <th colspan="2" style="min-width: 100px; padding-right:45px; text-align:right" v-else>{{$t('transcript.totalECTS')}}
                                                    <span class="font-weight-normal">
                                                        {{gpa[0] !== undefined ? gpa[0].ects_credits : 0}}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>

                                <template v-if="semester == semesters">
                                    <bottom :student="student" :program="program" :registrar="registrar"></bottom>
                                </template>
                            </div>
                        </div>
                    </div>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px"
                        v-if="secondary_courses.length">
                        <div class="card-body">

                            <top :student="student" :program="secondary_program" :local_gpa="local_gpa" :maximum_grade="maximum_grade" :report_date="report_date" :local_transcripts="local_transcripts"
                                :academic_year="secondary_program.academic_year"></top>

                            <div v-if="secondary_program.program_code == 'AAE'">
                                {{$t('transcript.aaeRemarksTerm')}}
                            </div>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{$t('transcript.code')}}</th>
                                            <th>{{$t('transcript.course')}}</th>
                                            <th class="text-center" v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                            <th class="text-center" v-else></th>
                                            <!-- <th class="text-center" v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                            <th class="text-center">{{$t('transcript.grade')}}</th>
                                            <th class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.sbsCredits')}}
                                            </th>
                                            <th class="text-center" v-else>{{$t('transcript.ectsCredits')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(course, index) in secondary_courses" :key="index">
                                            <td>{{course.course_code}}</td>
                                            <td>{{course.course_title}}</td>
                                            <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                            <td class="text-center" v-else></td>
                                            <td class="text-center" v-if="local_transcripts && course.local_grade != null">{{course.local_grade}}</td>
                                            <td class="text-center" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-else>{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-if="program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{course.sbs_credits}}</td>
                                            <td class="text-center" v-else>{{course.ects_credits}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4"></th>
                                            <th class="text-center" style="min-width: 100px"
                                                v-if="secondary_program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{secondary_sbs_credits}}</span>
                                            </th>
                                            <th class="text-center" style="min-width: 100px" v-else>
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{secondary_ects_credits}}</span>
                                            </th>
                                        </tr>
                                        <tr v-if="secondary_program.program_code=='AAE'">
                                            <th colspan="3"></th>
                                            <th colspan="2">
                                                {{$t('transcript.aaeRemarksCredit')}}
                                                <span class="font-weight-normal">120</span>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="3" v-if="local_transcripts">
                                                {{$t('transcript.localGradePointAverage', {local_gpa: secondary_local_gpa, maximum_grade: secondary_maximum_grade})}}
                                            </th>
                                            <th colspan="3" v-else>
                                                {{$t('transcript.gradePointAverage', {gpa: secondary_gpa})}}
                                            </th>
                                            <th colspan="2" style="min-width: 100px;text-align: center;"
                                                v-if="secondary_program.program_code == 'DBA' || program.program_type =='CAP Program'">
                                                {{$t('transcript.totalSBS')}}
                                                <span class="font-weight-normal">{{total_sbs_credits}}</span>
                                            </th>
                                            <th colspan="2" style="min-width: 100px;text-align: center;" v-else>
                                                {{$t('transcript.totalECTS')}}
                                                <span class="font-weight-normal">{{total_ects_credits}}</span>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <bottom :student="student" :program="program2" :registrar="registrar"></bottom>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="inDisplay == 'mabr'">
                <div class="col-md-10 mx-auto">
                    <download-transcript :id="id" :local_transcripts='local_transcripts' :localGradeLabel='localGradeLabel'  type="mabr" v-if="downloadBtns"></download-transcript>

                    <div class="card"
                        style="max-width: 820px; min-height: 760px; margin: 15px auto; padding: 100px 40px">
                        <div class="card-body">
                            <top-mabr :student="student" :program="program" :local_gpa="local_gpa" :maximum_grade="maximum_grade" :local_transcripts="local_transcripts" :report_date="report_date"
                                :academic_year="program.academic_year" :is_mabr="is_mabr"></top-mabr>

                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>{{$t('transcript.code')}}</th>
                                            <th>{{$t('transcript.course')}}</th>
                                            <th v-if="!local_transcripts">{{$t('transcript.percentage')}}</th>
                                            <th v-else></th>
                                            <!-- <th v-if="local_transcripts">{{ localGradeLabel }}</th> -->
                                            <th>{{$t('transcript.grade')}}</th>
                                            <th>{{$t('transcript.sbsCredits')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(course, index) in courses" :key="index">
                                            <td>{{course.course_code}}</td>
                                            <td>{{course.course_title}}</td>
                                            <td class="text-center" v-if="!local_transcripts">{{course.percentage}}</td>
                                            <td class="text-center" v-else></td>
                                            <td class="text-center" v-if="local_transcripts && course.local-grade != null">{{course.local_grade}}</td>
                                            <td class="text-center" v-else-if="course.local_grade == null">{{course.descriptive_grade}}</td>
                                            <td class="text-center" v-else>{{course.descriptive_grade}}</td>
                                            <td class="text-center">{{course.sbs_credits}}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4" v-if="local_transcripts">
                                                {{$t('transcript.localGradePointAverage', {local_gpa: local_gpa, maximum_grade: maximum_grade})}}
                                            </th>
                                            <th colspan="4" v-else>
                                                {{$t('transcript.gradePointAverage', {gpa: gpa})}}
                                            </th>
                                            <th style="min-width: 100px">
                                                {{$t('transcript.total')}}
                                                <span class="font-weight-normal">{{total_sbs_credits}}</span>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <bottom :student="student" :program="program" :registrar="registrar" :dba_ma_date="dba_ma_date"></bottom>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>
    </div>
</template>

<script>
    import DownloadTranscript from './DownloadTranscript.vue';
    import Top from '../views/transcript/_top';
    import TopMabr from '../views/transcript/_top_mabr';
    import Bottom from '../views/transcript/_bottom';

    export default {
        name: 'transcript',
        props: ['gradingScales', 'localGradeLabel', 'showLocalGrades', 'showSecondaryLocalGrades', 'dateFormat', 'id', 'program_code','studentProgram'],
        components: {
            DownloadTranscript,
            Top,
            TopMabr,
            Bottom
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                inDisplay: null,
                downloadBtns: false,

                program: {
                    id: null,
                    title: null,
                    code: null,
                    type: null,
                    academic_year: null
                },

                program2: {
                    id: null,
                    title: null,
                    code: null,
                    type: null,
                    academic_year: null
                },

                student: {
                    id: null,
                    student_number: null,
                    name: null,
                    birth_date: null,
                    birth_place: null,
                    partner_campus_location: null,
                    report_date: null,
                },

                courses: [],
                fpCourses: [],
                secondary_courses: [],
                pages: [],
                secondary_pages: [],

                report_date: null,
                registrar: null,
                semesters: null,
                secondary_semesters: null,

                sbs_credits: null,
                ects_credits: null,

                secondary_sbs_credits: null,
                secondary_ects_credits: null,

                total_sbs_credits: null,
                total_ects_credits: null,

                grades_points: null,
                gpa: null,
                fpGpa: null,
                secondary_gpa: null,
                local_gpa: null,
                fp_local_gpa: null,
                secondary_local_gpa: null,
                secondary_maximum_grade: null,
                maximum_grade: null,
                is_mabr: false,
                dba_ma_date: null,
                local_transcripts: false,
            }
        },

        methods: {
            show(type, local) {

                let url = '/api/' + (local?'localTranscripts':'transcripts');

                this.isLoading = true;
                this.clearAlert();

                this.local_transcripts = local;
                

                axios
                    .get(`${url}/${this.id}/${type}`)
                    .then(({
                        data
                    }) => {

                        this.program = data.program;
                        if (data.secondary_program) this.secondary_program = data.secondary_program;

                        this.student = data.student;
                        this.dba_ma_date = data.DBAMADate;
                        this.courses = data.courses;
                        this.secondary_courses = data.secondary_courses;

                        this.registrar = data.registrar;
                        this.report_date = data.report_date;
                        this.pages = data.pages;


                        if(local == true){
                            this.local_gpa = data.local_gpa;
                            this.maximum_grade = data.maximum_grade;
                            this.gpa = data.local_gpa;
                        }else{
                            this.gpa = data.gpa;
                            this.local_gpa = data.gpa;
                        }

                        this.downloadBtns = true;

                        if (data.sbs_credits) this.sbs_credits = data.sbs_credits;
                        if (data.sbs_credits) this.ects_credits = data.ects_credits;

                        if (data.secondary_sbs_credits) this.secondary_sbs_credits = data.secondary_sbs_credits;
                        if (data.secondary_ects_credits) this.secondary_ects_credits = data.secondary_ects_credits;

                        if (data.total_sbs_credits) this.total_sbs_credits = data.total_sbs_credits;
                        if (data.total_ects_credits) this.total_ects_credits = data.total_ects_credits;

                        if (data.grades_points) this.grades_points = data.grades_points;

                        if (data.pages && type == 'year') {
                            this.pages = data.pages;

                            if (this.pages.length == 0) {
                                this.showAlert(this.$t('transcript.notFound'), 'info');
                                this.downloadBtns = false;
                            }
                        }

                        if (data.pages && type == 'yearFp') {
                            this.pages = data.pages;

                            if (this.pages.length == 0) {
                                this.showAlert(this.$t('transcript.notFound'), 'info');
                                this.downloadBtns = false;
                            }
                        }

                        if (data.pages && type == 'yearFull') {
                            this.pages = data.pages;

                            if (this.pages.length == 0) {
                                this.showAlert(this.$t('transcript.notFoundSecondary'), 'info');
                                this.downloadBtns = false;
                            }
                        }

                        if (data.semesters) this.semesters = data.semesters;
                        if (data.is_mabr) this.is_mabr = data.is_mabr;

                        this.inDisplay = type;
                        this.isLoading = false;

                        if(local == true && type == 'yearFull'){
                                this.secondary_local_gpa = data.secondary_local_gpa;
                                this.secondary_maximum_grade = data.secondary_maximum_grade;
                                this.secondary_gpa = data.secondary_local_gpa;
                            }else{
                                this.secondary_gpa = data.secondary_gpa;
                                this.secondary_local_gpa = data.secondary_gpa;
                            }

                        if (type == 'yearMerged') {

                            if(local == true){
                                this.secondary_local_gpa = data.secondary_local_gpa;
                                this.secondary_maximum_grade = data.secondary_maximum_grade;
                                this.secondary_gpa = data.secondary_local_gpa;
                            }else{
                                this.secondary_gpa = data.secondary_gpa;
                                this.secondary_local_gpa = data.secondary_gpa;
                            }
                            this.program2 = data.program2;

                            if (data.pages) {
                                this.pages = data.pages;

                                if (this.pages.length == 0) {
                                    this.showAlert(this.$t('transcript.notFound'), 'info');
                                    this.downloadBtns = false;
                                }
                            }

                            if (data.secondary_pages) {
                                this.secondary_pages = data.secondary_pages;

                                if (this.secondary_pages.length == 0) {
                                    this.showAlert(this.$t('transcript.notFoundSecondary'), 'info');
                                    this.downloadBtns = false;
                                }
                            }

                            if (data.secondary_semesters) this.secondary_semesters = data.secondary_semesters;
                        }
                    })
                    .catch(error => {
                        console.log('error fetching transcript record');

                        this.inDisplay = null;
                        this.isLoading = false;
                    });
            },

            /**
             * Show alert
             */
            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            /**
             * Slear alert
             */
            clearAlert() {
                this.alertMessage = '';
                this.alertClass = '';
                this.alert = false;
            },
        }
    }

</script>
